import React, { useState, useEffect } from "react";
import { Badge, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";
import style from "./Account.module.scss";

const Requeriments = (props) => {
  const { orderId, accountId, orderPdf, readonly, hasAttachment, downloadAttachment } = props;
  const [state, setState] = useState({
    open: false,
    text: "",
    uploaded: props.hasFile || false,
  });
  const[maxSize, setMaxSize] = useState(0);
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      uploaded: props.hasFile || false,
    }));
  }, [props.hasFile]);

  const toggle = (save) => {
    if (save) {
      handleFileUpload(state.text);
    }

    setState((prevState) => ({
      ...prevState,
      open: !prevState.open,
      text: "",
    }));
  };

  const resetState = () => {
    const { setAttachment, onChangeOrder } = props;
    setAttachment({
      file: null,
    });
    onChangeOrder({
      AttachmentFileName: undefined,
      AttachmentFileType: undefined,
      HasFileUploadPending: undefined,
      AttachmentFileUploadPending: undefined,
    });
    setState({
      open: false,
      text: "",
      uploaded: false,
    });
  };

  const onChangeText = (text) => {
    setState((prevState) => ({
      ...prevState,
      text,
    }));
  };

  const handleFileUpload = (event) => {
    const { setAttachment, onChangeOrder } = props;
    const MAX_SIZE_MB = 3 * 1024 * 1024;
    if (typeof event === "string") {
      const fileBlob = new Blob([event], { type: "plain/text", endings: "native" });
      if (fileBlob.size > MAX_SIZE_MB){
        setMaxSize (1);
        return
      }else{
        setMaxSize (0);
        setAttachment({
          file: fileBlob
        });
      }
      
    } else {
      const uploadedFile = event.target.files[0];
      if (uploadedFile){
        if(uploadedFile.size > MAX_SIZE_MB){
          setMaxSize (1);
          return
        }else{
          setMaxSize (0);
          setAttachment({ file: uploadedFile });
        }
      }
    }

    onChangeOrder({
      AttachmentFileName: Math.random().toString(36).substring(9),
      AttachmentFileType: "none",
    });

    setState((prevState) => ({
      ...prevState,
      uploaded: true,
    }));
  };

  const attachmentInServer = hasAttachment && !hasAttachment.hasOwnProperty("uploadPending");

  return (
    <div className={style.requeriments}>
      {orderId && (
        <div className={style.line}>
          <span>Download order as pdf</span>
          <button
            className={`mr-1 btn btn-light ${style.pdf}`}
            tooltip="Download PDF"
            tooltip-position="bottom"
            onClick={() => orderPdf({ orderId })}
          >
            <img />
          </button>
        </div>
      )}

      <div className={style.line}>
      <span>Attachment (Max 3MB)</span>

        {!readonly && !state.uploaded && (
          <button
            className={`mr-1 btn btn-light ${style.upload}`}
            tooltip="Upload file"
            tooltip-position="bottom"
          >
            <img />
            <input type="file" className={style.inputFile} onChange={handleFileUpload} />
          </button>
        )}

        {!readonly && !state.uploaded && (
          <button
            className={`mr-1 btn btn-light ${style.pencil}`}
            tooltip="Enter text"
            tooltip-position="bottom"
            onClick={() => toggle()}
          >
            <i className={"fa fa-pencil"}></i>
          </button>
        )}
        {!readonly && state.uploaded && (
          <button
            className={`mr-1 btn btn-light ${style.pencil}`}
            tooltip="Remove attachment"
            tooltip-position="bottom"
            onClick={() => resetState()}
          >
            <i className={"fa fa-times"}></i>
          </button>
        )}

        {!attachmentInServer && (
          <Badge
            color={state.uploaded || (hasAttachment && hasAttachment.uploadPending) ? "success" : maxSize === 1 ? "red": "warning"}
            className={style.pending}
          >
            {state.uploaded || (hasAttachment && hasAttachment.uploadPending) ? "Uploaded" : maxSize === 1 ? "Too large":  "Pending"}
          </Badge>
        )}

        {attachmentInServer && (
          <button className="link" onClick={() => downloadAttachment({ orderId, accountId })}>
            download
          </button>
        )}
      </div>

      <ModalText toggle={toggle} open={state.open} text={state.text} onChangeText={onChangeText} />
    </div>
  );
};

const ModalText = ({ toggle, open, text, onChangeText }) => (
  <Modal isOpen={open} toggle={() => toggle()} className={style.modal}>
    <ModalHeader toggle={() => toggle()}>Attachment</ModalHeader>
    <ModalBody>
      <Input
        type={"textarea"}
        rows={2}
        placeholder={"Text"}
        value={text}
        onChange={(e) => onChangeText(e.target.value)}
      />
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={() => toggle()}>
        Cancel
      </Button>{" "}
      <Button color="primary" onClick={() => toggle(true)}>
        Save
      </Button>
    </ModalFooter>
  </Modal>
);

export default Requeriments;
